var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.$style.avatar,
    { [_vm.$style.defaultAvatar] : !_vm.has_avatar }
  ],style:(_vm.avatar_img)},[(!_vm.has_avatar)?_c('span',[_vm._v(" "+_vm._s(_vm.default_avatar)+" ")]):_vm._e(),(_vm.is_edit)?[_c('input',{class:_vm.$style.fileInput,attrs:{"accept":".jpg, .jpeg, .png","type":"file","id":"avatar-input"},on:{"change":_vm.uploaded_new_img}}),_c('label',{class:_vm.$style.avatarLabel,attrs:{"for":"avatar-input"}},[_c('v-icon',{class:_vm.$style.plusIcon},[_vm._v("mdi-plus")])],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }